import { Box, Tooltip, Typography } from "@material-ui/core";
import React from "react";

import { currencyFormatter, formatDatetime, nFormatter } from "../../../../services";
import { COLORS } from "../../../../theme/colors";
import { STATUS_MAP, ITEMS_PER_PAGE } from "../../constants";

export const unitListFormatter = {
  headers: [
    "Unit ID/Name",
    "Area",
    "Tenancy Status",
    "Tenancy name",
    "Electricity status",
    "MPAN",
    "Customer Account",
    "Leasing Exp. Date",
  ],
  groupColWidths: [12, 80, 8],
  colWidths: [12, 6, 13, 13, 13, 13, 13, 17],
  generateRow: unitListRow,
  generateGroupRow: unitListGroupRow,
};

export function unitListGroupRow(item, i, selectUnit) {
  return [
    <Typography noWrap key={i}>
      {
        <div
          style={{
            cursor: "pointer",
            height: "20px",
            lineHeight: "20px",
            letter: "0.2 px",
            fontWeight: "bold",
          }}
          onClick={(e) => {
            selectUnit(e, i);
          }}
        >
          {item.expanded ? <span>- {item.name}</span> : <span>+ {item.name}</span>}
        </div>
      }
    </Typography>,
    <Typography noWrap key={i}>
      {item.address}
    </Typography>,
    <Typography noWrap key={i} style={{ height: "24px", fontWeight: "bold" }}>
      {`${item.unit_info.length} units`}
    </Typography>,
  ];
}

export function unitListRow(item, i) {
  const mpan = item.mpan.join(", ");
  return [
    <Typography noWrap key={i}>
      {item?.unit_id?.toString()}
    </Typography>,
    nFormatter(item.area),
    <Typography style={{ color: item.tenancy_status !== "RENTED" ? COLORS.red : null }} key={i}>
      {STATUS_MAP[item.tenancy_status]}
    </Typography>,
    <Typography key={i}>{item.tenant_name}</Typography>,
    <Typography key={i} style={{ color: COLORS.green }}>
      {STATUS_MAP[item.electricity_status?.status]}
    </Typography>,
    <div key={i}>
      {mpan.length > 15 && item.mpan.length > 1 ? (
        <Tooltip title={mpan}>
          <div>{mpan.substring(0, 15) + "..."}</div>
        </Tooltip>
      ) : (
        mpan
      )}
    </div>,
    item.account_number,
    formatDatetime(item.leasing_end, "MMM D, YYYY"),
  ];
}

export const tenantUnitListFormatter = {
  headers: [
    "Tenant name",
    "Unit",
    "Total Sqft",
    "Electricity status",
    "MPAN",
    "Rental/Mon",
    "Start Date",
    "Exp. Date",
  ],
  groupColWidths: [12, 80, 8],
  colWidths: [13, 16, 6, 13, 17, 13, 11, 11],
  generateRow: unitListRow2,
  generateGroupRow: unitListGroupRow,
};

export function unitListRow2(item, i, currencySymbol) {
  const mpan = item.mpan.join(", ");

  return [
    <Typography key={i}>{item.tenant_name}</Typography>,

    <Typography noWrap key={i}>
      {item?.unit_id?.toString()}
    </Typography>,

    nFormatter(item.area),

    <Box key={i}>
      <Typography
        style={{
          color: {
            CONNECTED: COLORS.green,
            READY_TO_CONNECT: COLORS.purple,
            STAND_BY: COLORS.darks[0][50],
          }[item.electricity_status?.status],
        }}
      >
        {STATUS_MAP[item.electricity_status?.status]}
      </Typography>
      {item.electricity_status?.status === "CONNECTED" ? (
        <Typography key={i}>
          Since {formatDatetime(item.electricity_status.since_connected, "MMM D, YYYY")}
        </Typography>
      ) : null}
    </Box>,
    <div key={i}>
      {mpan.length > 15 && item.mpan.length > 1 ? (
        <Tooltip title={mpan}>
          <div>{mpan.substring(0, 15) + "..."}</div>
        </Tooltip>
      ) : (
        mpan
      )}
    </div>,
    item.total_rent !== null ? currencyFormatter(item.total_rent, currencySymbol) : "No Data",
    formatDatetime(item.leasing_start, "MMM D, YYYY"),
    formatDatetime(item.leasing_end, "MMM D, YYYY"),
  ];
}

export function paginationOfExpandableList(data, groupsPerPage, groupFieldName) {
  return data.reduce(
    (acc, item) => {
      if (item?.[groupFieldName]) {
        const pageIndex = Math.floor(acc.cnt / groupsPerPage);
        if (pageIndex >= acc.pageSizes.length) {
          acc.pageStarts.push(
            acc.pageSizes.length > 0 ? acc.pageSizes[acc.pageSizes.length - 1] : 0
          );
          acc.pageEnds.push(acc.pageSizes.length > 0 ? acc.pageSizes[acc.pageSizes.length - 1] : 0);
          acc.pageSizes.push(0);
        }

        acc.pageSizes[pageIndex] += 1;
        acc.pageEnds[pageIndex] += 1;
        acc.cnt += 1;
      } else {
        const pageIndex = acc.pageSizes.length > 0 ? Math.floor(acc.cnt / ITEMS_PER_PAGE) : 0;
        acc.pageSizes[pageIndex] = (acc.pageSizes[pageIndex] || 0) + 1;

        if (acc.pageSizes[pageIndex] === 1) {
          acc.pageStarts[pageIndex] = acc.cnt;
        } else {
          acc.pageEnds[pageIndex] = acc.cnt;
        }
        acc.cnt += 1;
      }
      return acc;
    },
    { cnt: 0, pageStarts: [], pageSizes: [], pageEnds: [] }
  );
}
